import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Table from "react-bootstrap/Table";
import {
  adminUserDomainDetails,
  exitingAdminDomainList,
} from "../../Services/postServices";
// import { exitingAdminDomainList } from "../../Services/postServices";
import { loader } from "../../redux/type";
import Accordion from "react-bootstrap/Accordion";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import { viewUser } from "../../Services/postServices";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { ssoRoleBydomain } from "../../Services/getServices";
import { userType } from "../../Services/postServices";

const DeptDashboard = () => {
  const dispatch = useDispatch();
  var [domainDet, setDomainDet] = useState([]);
  var [existingUser, setExistingUser] = useState([]);
  const userData = JSON.parse(localStorage.getItem("user"));
  //   console.log("DATATATA=", userData?.user?.id);
  // const id = userData?.user?.id;
  const id2=userData?.domainCodesByUserId[0]?.userId;
  const id = userData?.user?.userId;

  const name2=userData?.user?.firstName
  const mobileNo=userData?.user?.mobile
  const emailId=userData?.user?.emailId

  useEffect(() => {
    domainDetails();
    userTydetails();
    // ssoRoleByDomainName();
    
  }, []);
  var [roleList,setRoleList]=useState([]);
function userTydetails(){

  userType("BH" , (res)=>{

    if(res?.data?.status){
      setRoleList(res?.data?.result)

    }else{

    }
  })
}

  function domainDetails() {
    dispatch({ type: loader.startLoader });
    // let userId = 1791;

    let req = {
      "userId":id,
      "mobileNo":mobileNo,
      "email":emailId,
       
   }

    adminUserDomainDetails(req, (res) => {
      dispatch({ type: loader.stopLoader });
      if (res?.data?.status) {
        setDomainDet(res?.data?.result?.domainList);
        console.log("domain details=", res);
      } else {
        console.log(res);
      }
    });
  }

  var [num, setNum] = useState("0");
  function exitingListForDomain(domainCode) {
    dispatch({ type: loader.startLoader });
    // let userId = 1791;

    let req = {
      userId: id2,
      domainCode: domainCode,
    };

    exitingAdminDomainList(req, (res) => {
      dispatch({ type: loader.stopLoader });
      if (res?.data?.status) {
        setNum("2");
        setExistingUser(res?.data?.result);
        console.log("domain details=", res);
      } else {
        setNum("1");
        console.log("POLL",res);
      }
    });
  }

  const [viewUserList, setViewUserList] = useState([]);
  function viewUserDetails(genUserId, adminDomaincode) {
    let req = {
      userId: genUserId,
      domainCode: adminDomaincode,
    };
    dispatch({ type: loader.startLoader });

    viewUser(req, (res) => {
      dispatch({ type: loader.stopLoader });
      if (res?.data?.status) {
        setViewUserList(res?.data?.result);
      } else {
      }
    });
  }


  // var [roleList,setRoleList]=useState([]);
  function ssoRoleByDomainName(domainCo){

    ssoRoleBydomain(domainCo, (res)=>{

      if(res?.data?.status){
        setRoleList(res?.data?.result);

      }
      else{

      }
    })

  }

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showUpdate, setShowUpdae] = useState(false);

  const handleCloseUpdate = () => setShowUpdae(false);
  const handleShowUpdate = () => setShowUpdae(true);



  return (
    <>
      <div className="card shadow myprofileCard ">
        <div className="card-body overFlow p-md-3">
<h5>Welcome {name2},</h5>
<br></br>



          <h5 className="h2_heading">Dashboard</h5>

          {/* <Select
            options={options}
            isMulti
            value={selectedOptions}
            onChange={handleSelectedChange}
        /> */}

          <div className="row justify-content-around ">
            <div className="col-12">
              <div className="form-outline mb-3">
                <label className="form-label" for="id">
                  Domain Name:
                </label>

                <select
                  class="form-control form-select"
                  onChange={(e) => {
                    exitingListForDomain(e.target.value);
                    // desigByDomainName(e.target.value);
                    ssoRoleByDomainName(e.target.value);
                    // deptByDomainName(e.target.value);
                  }}
                >
                  <option value="0">Select Domain </option>

                  {domainDet.map((val) => {
                    return (
                      <option key={val} value={val.domainCode}>
                        {val.domainName}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          </div>

          {num === "2" ? (
            <>
              <h5>Existing Admin List</h5>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>User Id</th>
                    <th> Mobile No.</th>
                    <th>Designation</th>
                    <th>Email</th>
                    <th>Domain Code</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {existingUser?.map((val, index) => (
                    <tr key={index}>
                      <td>{existingUser[index]?.genricUserId} </td>
                      <td>{existingUser[index]?.mobileNumber}</td>
                      <td>{existingUser[index]?.userTypeName}</td>
                      <td>{existingUser[index]?.email}</td>
                      <td>{existingUser[index]?.domainCode}</td>
                      <td>
                        {/* <button className="btn btn-primary" style={{fontSize:"10px"}}> View</button> */}

                        <Button
                          variant="primary"
                          style={{ fontSize: "10px" }}
                          onClick={(e) => {
                            viewUserDetails(
                              existingUser[index]?.genricUserId,
                              existingUser[index]?.domainCode
                            );
                            handleShow();
                          }}
                        >
                          View
                        </Button>

                        <Modal show={show} onHide={handleClose}>
                          <Modal.Header closeButton>
                            <Modal.Title>View User</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <div className="row  ">
                              <div className="col-4">
                                <div className="form-outline mb-3">
                                  <label className="form-label" for="id">
                                    Name:
                                  </label>
                                  <input
                                    type="mobile"
                                    id="aadhaarcard"
                                    // onChange={(e) => setName(e.target.value)}
                                    value={
                                      viewUserList[0]?.userViewList[0]
                                        ?.firstName
                                    }
                                    disabled
                                    className="form-control"
                                    placeholder="Enter here"
                                  />
                                </div>
                              </div>
                              
                              <div className="col-4">
                                <div className="form-outline mb-3">
                                  <label className="form-label" for="id">
                                    Email:
                                  </label>
                                  <input
                                    type="mobile"
                                    id="aadhaarcard"
                                    // onChange={(e) => setName(e.target.value)}
                                    value={
                                      viewUserList[0]?.userViewList[0]
                                        ?.email
                                    }
                                    disabled
                                    className="form-control"
                                    placeholder="Enter here"
                                  />
                                </div>
                              </div>
                              <div className="col-4">
                                <div className="form-outline mb-3">
                                  <label className="form-label" for="id">
                                    Mobile No:
                                  </label>
                                  <input
                                    type="mobile"
                                    id="aadhaarcard"
                                    // onChange={(e) => setName(e.target.value)}
                                    value={
                                      viewUserList[0]?.userViewList[0]
                                        ?.mobileNumber
                                    }
                                    disabled
                                    className="form-control"
                                    placeholder="Enter here"
                                  />
                                </div>
                              </div>

                              <div className="col-4">
                                <div className="form-outline mb-3">
                                  <label className="form-label" for="id">
                                  Domain Code:
                                  </label>
                                  <input
                                    type="mobile"
                                    id="aadhaarcard"
                                    // onChange={(e) => setName(e.target.value)}
                                    value={
                                      viewUserList[0]?.userViewList[0]
                                        ?.domainCode
                                    }
                                    disabled
                                    className="form-control"
                                    placeholder="Enter here"
                                  />
                                </div>
                              </div>

                             





                            </div>
                           
                          </Modal.Body>
                          <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                              Close
                            </Button>
                            {/* <Button variant="primary" onClick={handleClose}>
                              Save Changes
                            </Button> */}
                          </Modal.Footer>
                        </Modal>


                        <Button
                          variant="primary"
                          style={{ fontSize: "10px",marginLeft: "2px" }}
                          onClick={(e) => {
                            
                            handleShowUpdate();
                          }}
                        >
                          Update
                        </Button>

                        <Modal show={showUpdate} onHide={handleCloseUpdate}>
                          <Modal.Header closeButton>
                            <Modal.Title>Update User</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <div className="row  ">

                              <div className="col-4">
                                <div className="form-outline mb-3">
                                  <label className="form-label" for="id">
                                    User Id:
                                  </label>
                                  <input
                                    type="mobile"
                                    id="aadhaarcard"
                                    // onChange={(e) => setName(e.target.value)}
                                    value={existingUser[index]?.genricUserId}
                                    disabled
                                    className="form-control"
                                    placeholder="Enter here"
                                  />
                                </div>
                                


                              </div>
                              
                          
                              <div className="col-4">
                                <div className="form-outline mb-3">
                                  <label className="form-label" for="id">
                                    User Name:
                                  </label>
                                  <input
                                    type="mobile"
                                    id="aadhaarcard"
                                    // onChange={(e) => setName(e.target.value)}
                                    value={existingUser[index]?.userName}
                                    disabled
                                    className="form-control"
                                    placeholder="Enter here"
                                  />
                                </div>
                                


                              </div>

                              <div className="col-4">
                                <div className="form-outline mb-3">
                                  <label className="form-label" for="id">
                                    Domain Code:
                                  </label>
                                  <input
                                    type="mobile"
                                    id="aadhaarcard"
                                    // onChange={(e) => setName(e.target.value)}
                                    value={existingUser[index]?.domainCode}
                                    disabled
                                    className="form-control"
                                    placeholder="Enter here"
                                  />
                                </div>
                                


                              </div>

                           

                              <div className="col-4">
                                <div className="form-outline mb-3">
                                  <label className="form-label" for="id">
                                    Roles:
                                  </label>
                                  <select
                  className="form-control form-select"
                  // onChange={(e) => {
                  //   setDomainCodeS(e.target.value);
                  //   desigByDomainName(e.target.value);
                  //   ssoRoleByDomainName(e.target.value);
                  //   deptByDomainName(e.target.value);
                    
                  // }}
                >
                  <option value="0">Select Roles </option>

                  {roleList.map((val) => {
                    return (
                      <option key={val} value={val.roleId}>
                        {val.roleName}
                      </option>
                    );
                  })}
                </select>
                                </div>
                                


                              </div>





                            </div>
                           
                          </Modal.Body>
                          <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseUpdate}>
                              Close
                            </Button>
                            <Button variant="primary" onClick={handleCloseUpdate}>
                              Save Changes
                            </Button>
                          </Modal.Footer>
                        </Modal>
                        
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          ) : 

          num==="1"?(<>
          <h5>No User Found</h5>
          </>):
          
          (
            <>
              <h5>Please Select Domain</h5>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default DeptDashboard;
